<template>
  <div class="put_import_container" :class="{ full_page: showSecPage }">
    <div v-show="!showSecPage" style="height: 100%">
      <div class="p_i_left">
        <OrderFormPoint ref="formCmp" @submit="conditionSearch"></OrderFormPoint>
      </div>
      <div class="p_i_right" v-show="!send">
        <div class="p_i_import center-center">暂无小区列表，输入筛选条件后直接提交订单</div>
      </div>
    </div>
    <div class="sec_page" v-if="showSecPage">
      <OrderConfirm v-if="send" :options="orderOptions" @confirmBack="send = false" :uuid="uuid"></OrderConfirm>
    </div>
  </div>
</template>

<script>
import searchLabelsMix from '@/utils/searchLabelsMix'
import searchPointMix from '@/utils/mixins/searchPointMix'
import OrderFormPoint from './components/OrderFormPoint' // 首次会展示 此组件就暂时不懒加载了

export default {
  name: 'PutOrderTimeLimitMain',
  mixins: [searchLabelsMix, searchPointMix],
  components: {
    OrderFormPoint,
    OrderConfirm: () => import('./OrderConfirm')
  },
  data() {
    return {
      communityList: [],
      uuid: '',
      discountList: [],
      orderOptions: {},
      send: false,
      conditionData: null,
      cpmAccountNum: '', // 勾选的合计预计流量
      searchReqObj: {}
    }
  },
  computed: {
    payWay() {
      return this.$store.state.order.choosePayWay // 'cpd', 'cpmL', 'cpmT', 'pkg'
    },
    showSecPage() { // 是否展示二级页面
      return this.send
    }
  },
  provide() {
    return {
      putOrderProvideData: {
        smartSortType: this.smartSortType
      }
    }
  },
  watch: {
    showSecPage(v) {
      this.$emit('showConfirm', v)
    }
  },
  created() {
    this.getDiscountList()
  },
  beforeDestroy() {
    this.resetSearchStoreCommon()
  },
  methods: {
    async conditionSearch(conditionData) {
      let opt = {}
      this.conditionData = conditionData
      let { startDate, endDate } = conditionData
      opt = {
        ...conditionData,
        selectSlotRequest: {
          endDate: endDate || '',
          startDate: startDate || ''
        }
      }
      this.searchReqObj = Object.assign({}, opt)
      this.orderOptions = {
        type: 'condition',
        data: [],
        isExport: false,
        conditionData: this.searchReqObj,
        needDays: 0,
        cpmAccountNum: this.cpmAccountNum,
        searchChargeWay: this.payWay
      }
      this.send = true
      this.setStoreSearchForConfirm(conditionData) // 请求成功之后再更新相关store数据 供确认订单准确使用
    },
    async getDiscountList() {
      let storeDiscountList = this.$store.state.common.discountList
      if (!storeDiscountList || storeDiscountList.length == 0) {
        await this.$store.dispatch('getDiscountList')
        storeDiscountList = this.$store.state.common.discountList
      }
      this.discountList = storeDiscountList
    }
  }
}
</script>

<style lang="scss" scoped>
.pkgpop_main {
  width: 310px;
  margin: 25px auto;
  text-align: center;
  font-size: 16px;

  span {
    color: #ff3973;
  }
}

.sec_page {
  // height: calc(100% + 50px);
  height: 100%;
}

.convert {
  color: #6296ff;
  margin-left: 20px;
  cursor: pointer;
  font-size: 12px;
}

.r_header {
  border-top: 1px solid #d4d4d4;
  border-bottom: 1px solid #d4d4d4;
  position: relative;
  top: -1px;
  height: 40px;
  overflow: hidden;

  .smart_sort {
    float: left;
    margin-left: 20px;
    font-weight: 550;

    i {
      font-size: 10px;
    }
  }
}

.put_import_container {
  position: relative;
  height: calc(100% - 50px);
  margin: 0 2px;

  &.full_page {
    height: 100%;
  }
}

.p_i_left {
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  bottom: 0;
  width: 360px;
  box-shadow: -1px 0 0 0 #e9e9e9 inset;
  overflow: auto;

  ::v-deep .el-form-item__label {
    font-weight: 700;
  }
}

.p_i_right {
  position: relative;
  height: 100%;
  margin-left: 360px;
  overflow-y: auto;
}

.p_i_result {
  height: 100%;
  min-width: 635px;
}

.import_img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 300px;
  height: 210px;
  margin-top: -105px;
  margin-left: -150px;
  cursor: pointer;
}

.r_b_search {
  position: relative;
  line-height: 40px;

  .s_input {
    position: relative;
    z-index: 1;
    background: #fff;
    display: inline-block;
    width: 220px;
    border-right: 1px solid #e9e9e9;
    transition: all 0.8s;

    &.is_condition {
      box-shadow: 2px 0px 10px 0px rgba(255, 57, 115, 0.2), -1px 0px 0px 0px rgba(233, 233, 233, 1), 0px 1px 0px 0px rgba(255, 57, 115, 1);
      float: right;
    }

    &.no-time {
      width: 300px;

      &.highlight {
        width: 380px;

        // box-shadow: 2px 0px 10px 0px rgba(255, 57, 115, 0.2), -1px 0px 0px 0px rgba(233, 233, 233, 1), 0px 1px 0px 0px rgba(255, 57, 115, 1);
        .search_text {
          opacity: 1;
        }
      }
    }

    &.highlight {
      width: 300px;

      // box-shadow: 2px 0px 10px 0px rgba(255, 57, 115, 0.2), -1px 0px 0px 0px rgba(233, 233, 233, 1), 0px 1px 0px 0px rgba(255, 57, 115, 1);
      .search_text {
        opacity: 1;
      }
    }

    .search_text {
      display: inline-block;
      opacity: 0;
      width: 24px;
      font-size: 12px;
      vertical-align: middle;
      cursor: pointer;
      color: #999;
    }

    .el-input {
      display: inline-block;
      width: calc(100% - 34px);
    }

    ::v-deep .el-input__inner {
      font-size: 12px;
      padding-left: 40px;
      border: none;
    }

    ::v-deep .el-input__prefix {
      left: 18px;
    }

    ::v-deep .iconfont {
      font-size: 16px;
    }

    ::v-deep .el-input__suffix-inner {
      position: relative;
      top: 1px;
    }
  }

  .s_msg {
    display: inline-block;
    padding-right: 20px;
    font-size: 14px;
    line-height: 20px;
    border-right: 1px solid #e9e9e9;

    .hl {
      color: #3083f2;
      font-style: normal;
    }
  }

  .s_button {
    margin-left: 20px;
    margin-right: 20px;
    color: #878a92;
    font-size: 14px;
  }
}

.r_b_ul.empty::after {
  display: block;
  margin: 10px;
  padding: 52px;
  content: '暂无结果，换个名称重新试试吧~';
  color: #999;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  background-color: #f5f5f5;
}

.r_b_list {
  min-height: 124px;
  padding-left: 20px;
  margin-left: 0;
  width: 100%;
  box-shadow: 0 -1px 0 0 #e9e9e9 inset;

  ::v-deep .el-checkbox__label {
    vertical-align: middle;
    width: calc(100% - 13px);
  }

  &:hover {
    background: #e9e9e9;

    ::v-deep .label_item {
      background: #fff;
    }
  }
}

.community_outer {
  vertical-align: middle;
  margin-left: 12px;
  width: calc(100% - 26px);
}

.r_body {
  height: calc(100% - 100px);
  overflow-y: auto;
  overflow-x: hidden;

  &.is_condition {
    height: calc(100% - 140px);
  }
}

.sort_num {
  border-top: 1px solid #e9e9e9;
  position: relative;
  top: -1px;
  line-height: 40px;
  background: #fbfbfb;
  padding: 0 20px;
  font-size: 12px;

  .sort_btn {
    cursor: pointer;
    color: #ff3973;
    margin-left: 15px;
  }

  ::v-deep .el-input-number {
    width: 80px;
    margin-right: 10px;

    input {
      text-align: left;
    }

    > span {
      width: 20px;
    }

    .el-input__inner {
      padding-right: 0;
      padding-left: 10px;
    }
  }

  ::v-deep .el-select {
    position: relative;
    z-index: 1;

    // margin-right: 10px;
    input {
      width: 36px;
      text-align: left;
      padding: 0;
      padding-right: 10px;
      border: none;
      background: none;
      color: #7825fa;
    }

    .el-input__icon {
      display: none;
    }
  }

  .el-icon-caret-bottom {
    color: #7825fa;
    margin-right: 5px;
    position: relative;
    z-index: 0;
    left: -9px;
  }
}

.r_footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: grid;
  grid-template-columns: 84px auto 160px;
  grid-template-rows: 32px 28px;
  grid-auto-flow: column;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 -1px 0 0 #e9e9e9;
  z-index: 1;

  .el-checkbox {
    grid-row: 1 / 3;
    margin-left: 20px;
  }

  .r_checkbox_label {
    font-size: 14px;
  }

  .f_import_button {
    grid-row: 1 / 3;
    color: #fff;
    width: 120px;
    height: 40px;
    margin-left: 20px;
    font-size: 14px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border-radius: 4px;
    border: none;
  }

  .r_f_price {
    padding-top: 7px;
    line-height: 25px;
    font-family: Akrobat;

    .hl {
      font-size: 20px;
      font-weight: 800;
    }

    .del {
      margin-left: 10px;
      color: #666666;
      font-size: 14px;
      line-height: 17px;
      text-decoration: line-through;
    }
  }

  .r_f_msg {
    padding-bottom: 6px;
    color: #999;
    font-size: 14px;
    line-height: 20px;
  }

  .hl {
    color: #ff3973;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
  }

  .dark {
    color: #282729;
    font-size: 14px;
    line-height: 20px;
  }
}

em {
  font-style: normal;
}

.progress_box {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 400px;
  height: 64px;
  margin-left: -200px;
  margin-top: -32px;
  padding: 20px;
  border: 1px solid #d4d4d4;
  border-radius: 4px;

  .file_name {
    color: #666;
    font-size: 12px;
    line-height: 17px;

    .iconfont {
      margin-right: 6px;
      vertical-align: middle;
    }
  }

  ::v-deep .el-progress-bar {
    padding-right: 0;
    margin-right: 0;
  }

  ::v-deep .el-progress__text {
    position: absolute;
    right: 0;
    top: -100%;
    color: #ff3973;
  }

  ::v-deep .el-progress-bar__inner {
    background-color: #ff3973;
  }

  ::v-deep .el-progress-bar__outer {
    height: 3px !important;
  }

  .close_btn {
    position: absolute;
    right: -34px;
    top: 50%;
    width: 24px;
    height: 24px;
    margin-top: -12px;
    color: #282729;
    text-align: center;
    line-height: 24px;
    border-radius: 50%;
    border: 1px solid #d4d4d4;
    cursor: pointer;
  }
}
</style>
